// extracted by css-extract-rspack-plugin
export default {"cls1":"NewCourses-cls1_yBw","cls2":"NewCourses-cls2_cek NewCourses-cls1_yBw"};